import PropTypes from 'prop-types'
import { Button } from 'antd'
import { useStepIndex, useStepActions } from './hooks/useSteps'

const ResetStepButton = ({ children = '取消', onClick, ...props }) => {
  const [currentStep] = useStepIndex()
  const { resetSteps } = useStepActions()

  const handleClick = (e) => {
    if (onClick) {
      onClick(e)
    }
    resetSteps()
  }

  if (currentStep === 0) {
    return null
  }

  return (
    <Button
      {...props}
      size='large'
      onClick={handleClick}
    >
      {children}
    </Button>
  )
}

ResetStepButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func
}

export default ResetStepButton
